interface dispensaryNormalizeProps {
    data: {
        dispensaryStates: {
            nodes: any[];
        }
    }
}

export const dispensaryHashNormalize = ( dispensaries: dispensaryNormalizeProps ) => {
    //  This is a hash map 
    return dispensaries.data.dispensaryStates.nodes.reduce((obj: any, data: any)=> {
        obj[data.name] = data;
        return obj;
    },{});
}

export const dispensaryDropDownNormalize = ( dispensaries: dispensaryNormalizeProps ) => {
    return dispensaries.data.dispensaryStates.nodes.map((data: any)=> {
        let value = data.name;
        return { value, label: value }
    });
}